import React, { useState } from 'react';
import ApartmentService from '../../../services/ApartmentService.js';
import { useNavigate } from 'react-router-dom'
import SellApartmentComponent from './SellApartmentComponent.jsx';
import PrintCertificateComponent from './PrintCertificateComponent.jsx';
import InfoComponent from './InfoComponent';
import UpdateApartmentComponent from './UpdateApartmentComponent.jsx';
import ApartmentTenantMoreInfoComponent from './ApartmentTenantMoreInfoComponent.jsx';
import EditApartmentTenantComponent from './EditApartmentTenantComponent.jsx';

function MoreInfoComponent(props) {
    const navigate = useNavigate();
    
    const [editApartment, setEditApartment] = useState(false);
    const [sellApartment, setSellApartment] = useState(false);
    const [printCertificate, setPrintCertificate] = useState(false);
    const [createTenant, setCreateTenant] = useState(false);

    const cancelOnSale = (e) => {
        e.preventDefault();

        if (window.confirm("Vil du afslutte salget af nr:" + props.apartment.number)) {
            ApartmentService.saleApartment({ ...props.apartment, for_sale: false }).catch(function (err) {
                alert("Der opstod en fejl");
                console.log("Error saving", err);
            });

            navigate("/fraflyttere?apartment=" + props.apartment.number);
        }
    };

    const deleteApartment = (e) => {
        e.preventDefault();
        if (window.confirm("Er du sikker på at du vil slette nr:" + props.apartment.number)) {
            var id = props.apartment.id;
            ApartmentService.deleteApartment({
                id: id
            }).then(() => {
                // Refresh apartment list and reset state if callback provided
                if (props.onApartmentDeleted) {
                    props.onApartmentDeleted({
                        resetSelectedApartment: true,
                        resetCreateNew: true
                    });
                }
                // Navigate away from deleted apartment
                navigate("/lejligheder");
            }).catch(function (err) {
                alert("Der opstod en fejl");
                console.log("Error deleting", err);
            });
        }
    };

    const redigerClick = () => {
        setEditApartment(!editApartment);
    };

    const salesClick = () => {
        setSellApartment(!sellApartment);
    };

    const printCertificateClick = () => {
        setPrintCertificate(!printCertificate);
    };

    const toggleCreate = () => {
        setCreateTenant(!createTenant);
    };

    var tenants = props.apartment.apartmentTenants.map(function (apartmentTenant) {
        return (<React.Fragment key={apartmentTenant.id}>
            <ApartmentTenantMoreInfoComponent apartment={props.apartment} apartmentTenant={apartmentTenant} warning={props.apartment.apartmentTenants.length > 2 ? "table-warning" : ""}></ApartmentTenantMoreInfoComponent>
        </React.Fragment>)
    });

    var createTenantScaffold = { apartment_id: props.apartment.id, tenant: { firstname: '', lastname: '', phone: '', email: '' }, seniority_date: null, seniority_date2: null }

    return (
            <tr>
                <td colSpan="7">
                    <div className="row">
                        <div className="col-md-12">
                            {tenants}
                        </div>
                    </div>
                    {
                        createTenant &&
                        <div className="row">
                            <div className="col-md-12">
                                <EditApartmentTenantComponent apartment={props.apartment} apartmentTenant={createTenantScaffold} toggleEdit={toggleCreate}></EditApartmentTenantComponent>
                            </div>
                        </div>
                    }
                    {
                        props.apartment.apartmentTenants.length < 2 &&
                        <div className="row mb-2">
                            <div className="col-md-12">
                                <button className="btn btn-primary" onClick={toggleCreate}>Tilføj beboer</button>
                            </div>
                        </div>
                    }

                    {!editApartment ?
                        <InfoComponent apartment={props.apartment}></InfoComponent>
                        :
                        <UpdateApartmentComponent apartment={props.apartment} redigerClick={redigerClick}></UpdateApartmentComponent>}
                    <div className="row mt-2">
                        <div className="col-md-12">
                            {!sellApartment ?
                                <React.Fragment>
                                    {props.apartment.for_sale ?
                                        <React.Fragment>
                                            <button className="btn btn-primary" onClick={cancelOnSale}>Stop salg</button>
                                            <button className="btn btn-primary ml-2" onClick={salesClick}>Rediger pris</button>
                                        </React.Fragment>
                                        :
                                        <button className="btn btn-primary" onClick={salesClick}>Sæt til salg</button>}
                                    <button className="btn btn-primary ml-2" onClick={deleteApartment}>Slet bolig</button>
                                </React.Fragment>
                                :
                                <React.Fragment>
                                    <button className="btn btn-primary ml-2" onClick={deleteApartment}>Slet bolig</button>
                                </React.Fragment>}

                            <React.Fragment>
                                <button className="btn btn-primary ml-2" onClick={redigerClick}>Rediger</button>
                            </React.Fragment>
                            <React.Fragment>
                                <button className="btn btn-primary ml-2" onClick={printCertificateClick}>Print andelsbevis</button>
                            </React.Fragment>
                        </div>
                    </div>
                    <PrintCertificateComponent printCertificate={printCertificate} apartment={props.apartment} printCertificateClick={printCertificateClick}></PrintCertificateComponent>
                    <SellApartmentComponent sellApartment={sellApartment} apartment={props.apartment} salesClick={salesClick}></SellApartmentComponent>
                </td>
            </tr>
        );
    }

export default MoreInfoComponent;